import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {handleScrollToHash} from "../services/services";
import PhoneSwiper from "../components/Common/PhoneSwiper";
import CustomTabs from "../components/Common/CustomTabs";
import TopUp from "../components/SHB/TopUp";
import Withdraw from "../components/SHB/Withdraw";


const dataTopUp = [
	{id: 0, title: 'Tại giao diện chính, chọn “Nạp / Rút tiền”'},
	{id: 1, title: 'Chọn “Nạp tiền vào ví”'},
	{id: 2, title: 'Nhập số tiền cần nạp và nhấn “Tiếp tục”', subtitle: ['Lưu ý: Số tiền nạp tối thiểu 10.000 VNĐ']},
	{
		id: 3, title: 'Xác nhận thông tin nạp tiền.\n' +
			'Tại Nguồn nạp chọn “Napas”'
	},
	{id: 4, title: 'Nhập thông tin thẻ và nhấn “Nạp tiền”'},
	{id: 5, title: 'Thực hiện các bước xác thực theo ngân hàng phát hành'},
	{id: 6, title: 'Nạp tiền thành công. Bạn có thể quay về trang chủ để kiểm tra số dư Ví.'}
];

const dataWithdraw = [
	{
		id: 0,
		title: 'Tại giao diện chính, chọn “Nạp / Rút tiền”',
	},
	{
		id: 1,
		title: 'Chọn “Rút tiền về ngân hàng”',
	},
	{id: 2, title: 'Nhập số tiền cần rút và “Tiếp tục”', subtitle: ['Lưu ý: Số tiền rút tối thiểu 50.000 VNĐ']},
	{
		id: 3, title: 'Chọn “Ngân hàng nhận tiền”',
	},
	{id: 4, title: 'Nhập thông tin Số thẻ / Số tài khoản ngân hàng nhận tiền'},
	{id: 5, title: 'Kiểm tra thông tin và nhấn “Tiếp tục”'},
	{id: 6, title: 'Nhập mã PIN để xác thực giao dịch'},
	{id: 7, title: 'Chọn “Xác nhận”'},
	{id: 8, title: 'Rút tiền thành công'},
];

const LinkGuideNAPAS = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [step, setStep] = useState(0);
	const location = useLocation();
	const {hash} = location || {};
	
	useEffect(() => {
		handleScrollToHash({sectionId: hash.substring(1)});
	}, [hash]);
	
	const tabs = [
		{label: 'Nạp tiền vào Ví', quantity: 7, content: <TopUp isSHB data={dataTopUp} setStep={setStep} step={step}/>},
		{
			label: 'Rút tiền về ngân hàng',
			quantity: 9,
			content: <Withdraw isSHB data={dataWithdraw} setStep={setStep} step={step}/>
		},
	];
	
	const onClickTab = (index) => {
		setActiveTab(index);
	}
	
	return (
		<div className="mx-auto w-full animate-fadeIn text-sm space-y-5 md:space-y-10 pt-10">
			<div className='flex justify-center items-center text-center space-x-4 text-sm md:text-[17px] font-bold'>
				<div>
					Hướng dẫn Liên kết/ Nạp / Rút tiền với tài khoản Ngân hàng
				</div>
				<img src='/img/napas.svg' alt='napas'/>
			</div>
			
			<div className="mx-auto w-fit">
				<CustomTabs
					data={tabs}
					onClickTab={onClickTab}
					activeTab={activeTab}
				/>
				<div
					className='flex flex-wrap md:font-normal justify-center items-center md:justify-start md: md:items-start font-bold md:space-x-14'>
					<div
						className="bg-transparent rounded-b-lg pb-4 md:pb-0 mx-auto"
						role="tabpanel"
						id={`tabpanel-${activeTab}`}
						aria-labelledby={`tab-${activeTab}`}
					>
						<PhoneSwiper
							path={'guild-step/linked-step-napas'}
							activeTab={activeTab}
							step={step}
							setStep={setStep}
							setActiveTab={setActiveTab}
							quantity={tabs[activeTab]?.quantity}
						/>
					</div>
					{tabs[activeTab].content}
				</div>
			</div>
			<img className="z-[-1] mt-[-100px] md:mt-[-200px] w-full" src="/img/bg-city.png" alt="bg-city"/>
		</div>
	)
};

export default LinkGuideNAPAS;
